'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect } from 'react';
import { useDocumentoPdfDownload } from '@/shared/hooks/useDocumentoPdfDownload';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchSentencaArbitral } from '../store/sentenca/actions';
import { selectSentencaArbitral, selectSentencaArbitralError, selectSentencaArbitralLoading, selectSentencaArbitralNaoPublicada, selectSentencaArbitralSemPermissao } from '../store/sentenca/selectors';
import type { OrigemDocumentoEncerramento } from '../types/encerramento.types';

// A sentença é única por processo — secretaria, árbitro, advogado, parte e notificado leem
// exatamente a mesma peça, sem variação de conteúdo por origem. A `origem` só escolhe o
// endpoint do papel (cada porta exige a sessão daquele papel); o payload é idêntico nos cinco.
export function useSentencaArbitral(processoId, origem) {
  const $ = _c(21);
  const dispatch = useAppDispatch();
  const sentenca = useAppSelector(selectSentencaArbitral);
  const isLoading = useAppSelector(selectSentencaArbitralLoading);
  const error = useAppSelector(selectSentencaArbitralError);
  const semPermissao = useAppSelector(selectSentencaArbitralSemPermissao);
  const naoPublicada = useAppSelector(selectSentencaArbitralNaoPublicada);
  let t0;
  if ($[0] !== dispatch || $[1] !== origem || $[2] !== processoId) {
    t0 = () => {
      dispatch(fetchSentencaArbitral({
        origem,
        id: processoId
      }));
    };
    $[0] = dispatch;
    $[1] = origem;
    $[2] = processoId;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const recarregar = t0;
  let t1;
  let t2;
  if ($[4] !== recarregar) {
    t1 = () => {
      recarregar();
    };
    t2 = [recarregar];
    $[4] = recarregar;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  const t3 = sentenca?.numeroProcesso ?? processoId;
  let t4;
  if ($[7] !== t3) {
    t4 = t3.toLowerCase();
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `sentenca-arbitral-${t4}.pdf`;
  let t6;
  if ($[9] !== t5) {
    t6 = {
      fileName: t5
    };
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const {
    documentoRef,
    isDownloadingPdf,
    baixarPdf
  } = useDocumentoPdfDownload(t6);
  const imprimir = _temp;
  let t7;
  if ($[11] !== baixarPdf || $[12] !== documentoRef || $[13] !== error || $[14] !== isDownloadingPdf || $[15] !== isLoading || $[16] !== naoPublicada || $[17] !== recarregar || $[18] !== semPermissao || $[19] !== sentenca) {
    t7 = {
      sentenca,
      isLoading,
      error,
      semPermissao,
      naoPublicada,
      recarregar,
      documentoRef,
      isDownloadingPdf,
      baixarPdf,
      imprimir
    };
    $[11] = baixarPdf;
    $[12] = documentoRef;
    $[13] = error;
    $[14] = isDownloadingPdf;
    $[15] = isLoading;
    $[16] = naoPublicada;
    $[17] = recarregar;
    $[18] = semPermissao;
    $[19] = sentenca;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}
function _temp() {
  if (typeof window === "undefined") {
    return;
  }
  window.print();
}